import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { Component } from 'vue';
import { addSuffix } from '../../../utils/utils';

interface Props {
  size?: string | number,
  responseSize?: string | number,
  customClass?: string,
  icon?: Component,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    size: null,
    responseSize: null,
    customClass: null,
    icon: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  size?: string | number,
  responseSize?: string | number,
  customClass?: string,
  icon?: Component,
}




const customStyle = computed(() => (props.size ? `width: ${addSuffix(props.size)};height: ${addSuffix(props.size)};` : ''));

function handleClick(event: Event) {
  emit('click', event);
}

return { __sfc: true,props, emit, customStyle, handleClick }
}

})